$(function() {
    //inputフォーカス判定
	$('.focus_ele').each(function(n) {
		forcusCheck(n);
		var $elm = $('.focus_ele:eq(' + n + ')');
		$(document).on('change', $elm, function() {
			forcusCheck(n);
		});
	});
	function forcusCheck(n) {
		var $elm = $('.focus_ele:eq(' + n + ')');
		var str = $elm.val();
		if(str === '') {
			$elm.parent().removeClass('keep');
		} else {
			$elm.parent().addClass('keep');
		}
	}
});